import React, { VFC } from 'react';

import { useId } from 'react-id-generator';

import ArticleBlock from '/components/ArticleBlock';
import { ImageColumn } from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';

import styles from './BlockImageWall.scss';

const WALL_4_SIZES = [
  { width: 650, aspect: '650/615' },
  { width: 935, aspect: '935/305' },
  { width: 450, aspect: '450/295' },
  { width: 470, aspect: '470/295' },
];

const WALL_7_SIZES = [
  { width: 520, aspect: '520/515' },
  { width: 625, aspect: '625/260' },
  { width: 425, aspect: '425/260' },
  { width: 530, aspect: '530/240' },
  { width: 520, aspect: '520/515' },
  { width: 520, aspect: '520/260' },
  { width: 530, aspect: '530/260' },
];

const BlockImageWall: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  blockContent,
  ...props
}) => {
  const columns = blockContent?.columns?.list || [];
  setAnimationComplete(animationStep >= 1);
  const is4ImageWall = columns.length == 4;

  const ids = useId(columns.length);

  return (
    <ArticleBlock
      {...props}
      hideFooter={animationEnabled && !animationStep}
      blockContent={blockContent}
      titleCentered
      offset={1}
    >
      <div className={is4ImageWall ? styles.wall4 : styles.wall7}>
        {columns.map(
          (column: ColumnContainerJson, idx: number) =>
            column.name === 'media' &&
            column.elements.image &&
            column.elements.image.type === 'image' && (
              <div key={ids[idx]}>
                <ImageColumn
                  {...column.elements.image}
                  imageSize={
                    is4ImageWall ? WALL_4_SIZES[idx] : WALL_7_SIZES[idx]
                  }
                  hide={animationEnabled && !animationStep}
                />
              </div>
            ),
        )}
      </div>
    </ArticleBlock>
  );
};

BlockImageWall.displayName = 'BlockImageWall';
export default BlockImageWall;
